<template>
  <div class="pv-error">
    No pudimos recuperar la información de su pedido.
    <br />
    <ul>
      <li>
        Si el pedido fue realizado en las últimas 3 horas, es posible que aún el
        mismo no haya sido confirmado en nuestros sistemas.
      </li>
    </ul>
    <br />

    <el-button
      type="primary"
      size="default"
      v-if="!pedido"
      @click="getError(pedido)"
      >Cerrar ventana</el-button
    >
    <el-button
      type="primary"
      size="default"
      v-if="pedido"
      @click="getError(pedido)"
      >Reintentar</el-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      pedido: this.$route.params.pedido ? this.$route.params.pedido : 0,
    };
  },
  methods: {
    getError(pedido) {
      if (pedido) {
        location.reload();
        return false;
      } else {
          location.reload();
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pv-error {
  background: $bgError;
  padding: 20px;
  border-bottom: 1px dashed darksalmon;
}
.pv-error ul > li {
  text-align: left;
}
</style>